'use client';
import { useContext } from 'react';
import Link from 'next/link';

import { StoreContext } from '../Store';
import { DisplayBanner } from './HomeBanner';

const FooterBanner = () => {
  const { settingsState } = useContext(StoreContext);
  const [settings] = settingsState;

  return (
    <>
      <div className="w-full">
        <Link href={settings?.footerBannerLink || ''}>
          <DisplayBanner banner={settings?.footerBanner || null} />
        </Link>
      </div>
    </>
  );
};

export default FooterBanner;
